import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IEventTodoList,
	IOrganizationEvent,
	IOrganizationEventRequest,
	IOrganizationSponsorCategoryResponse,
} from '../../utils/types';
//services
import {OrganizationEventService} from '@/utils/services/organization-event.service';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getEvent = createAsyncThunk(ACTION_TYPE.EVENT, async (reqBody: string | number, {rejectWithValue}) => {
	try {
		const eventResponse: AxiosResponse<IOrganizationEvent> = await OrganizationEventService.getEvent(reqBody);

		return eventResponse.data;
	} catch (error) {
		return rejectWithValue(getErrorResponse(error));
	}
});

export const getEvents = createAsyncThunk(ACTION_TYPE.EVENTS, async (orgId: number, {rejectWithValue}) => {
	try {
		const eventResponse: AxiosResponse<IOrganizationEvent[]> = await OrganizationEventService.getEvents(orgId);

		return eventResponse.data;
	} catch (error) {
		return rejectWithValue(getErrorResponse(error));
	}
});

export const getEventSponsorCategories = createAsyncThunk(
	ACTION_TYPE.EVENT_SPONSOR_CATEGORIES,
	async (orgId: number, {rejectWithValue}) => {
		try {
			const eventResponse: AxiosResponse<IOrganizationSponsorCategoryResponse[]> =
				await OrganizationEventService.getSponsorCategories(orgId);

			return eventResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getEventTodoList = createAsyncThunk(
	ACTION_TYPE.EVENT_TODO_LIST,
	async ({id, isDone}: {id: number; isDone: boolean}, {rejectWithValue}) => {
		try {
			const eventResponse: AxiosResponse<IEventTodoList[]> = await OrganizationEventService.getEventTodoList(
				id,
				isDone
			);

			return eventResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const updateEvent = createAsyncThunk(
	ACTION_TYPE.EVENT_UPDATE,
	async ({id, reqBody}: {reqBody: IOrganizationEventRequest; id: number}, {rejectWithValue}) => {
		try {
			const eventResponse: AxiosResponse<IOrganizationEvent> = await OrganizationEventService.updateEvent(id, reqBody);
			return eventResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getEventBySlug = createAsyncThunk(
	ACTION_TYPE.EVENT_BY_SLUG,
	async (reqBody: string, {rejectWithValue}) => {
		try {
			const eventResponse: AxiosResponse<IOrganizationEvent> = await OrganizationEventService.getEventBySlug(reqBody);

			return eventResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
